import r from "./ghl-ui.es1239.js";
import a from "./ghl-ui.es1240.js";
import p from "./ghl-ui.es1241.js";
import s from "./ghl-ui.es1242.js";
import i from "./ghl-ui.es1243.js";
import m from "./ghl-ui.es1244.js";
function t(o) {
  var e = this.__data__ = new r(o);
  this.size = e.size;
}
t.prototype.clear = a;
t.prototype.delete = p;
t.prototype.get = s;
t.prototype.has = i;
t.prototype.set = m;
export {
  t as default
};
